import React, { useState, useEffect, useRef, useCallback, forwardRef, useImperativeHandle } from 'react'
import Menu from '../../../wui-menu/src'
import { PopMenuProps } from '../iTabs'
import { MenuProps } from '../../../wui-menu/src/iMenu'

const PopMenu = forwardRef<any, PopMenuProps>((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [activeKey, setActiveKey] = useState('');
    const [position, setPosition] = useState<Record<string, string | number>>({});
    const { onPopMenuIsShow, onMenuClick, items, clsPrefix } = props;

    const mounted = useRef(true);
    const menuBox = useRef<HTMLDivElement | null>(null);

    // 判断n是否在root内
    const contains = useCallback((root: any, n: any) => {
        let node: any = n;
        while (node) {
            if (node === root) return true;
            node = node.parentNode
        }
        return false;
    }, []);

    // 隐藏右键菜单
    const hide = useCallback(() => {
        setVisible(false);
        onPopMenuIsShow(false);
    }, [props.onPopMenuIsShow]);

    // 点击contextmenu以外的地方将其关闭
    const onDocumentClick = useCallback((event: any) => {
        if (!mounted.current) return;// 解决IE下报错findDOMNode
        let target = event.target;
        let contextDom = menuBox.current;
        if (!contains(contextDom, target)) {
            hide();
        }
    }, [contains, hide]);

    useEffect(() => {
        mounted.current = true;
        document.addEventListener('click', onDocumentClick);

        return () => {
            mounted.current = false;
            document.removeEventListener('click', onDocumentClick);
        };
    }, [onDocumentClick]);

    const onSelect: MenuProps['onSelect'] = useCallback((val: any) => {
        onMenuClick!(val?.key, activeKey);
        hide();
    }, [props.onMenuClick, activeKey, hide]);

    const renderMenus = useCallback(() => {
        // 在渲染前检查是否有有效的菜单项
        const hasValidItems = items &&
            Array.isArray(items) &&
            items.length > 0 &&
            items.some(item =>
                item &&
                typeof item === 'object' &&
                item.key != null &&
                item.key !== '' &&
                item.text != null &&
                item.text !== ''
            );

        // 如果没有有效项，不渲染。因为有用户在这里面做条件判断，绕开了tabs里的空菜单检查机制
        if (!hasValidItems) {
            return;
        }
        let menu = (
            items!.map(item => {
                return (item && <Menu.Item key={item.key}>{item.text}</Menu.Item>);
            })
        );

        return (<Menu onSelect={onSelect} className={`${clsPrefix}-close-menu`}>{menu}</Menu>);
    }, [props.items, props.clsPrefix, onSelect]);

    // 显示右键菜单
    const show = useCallback((event: React.MouseEvent, activeKey: string, showX: number, showY: number) => {
        let leftNum = showX !== undefined ? showX : event.clientX;
        let newPosition = {
            left: leftNum,
            top: showY !== undefined ? showY : event.clientY,
            position: 'absolute',
            zIndex: '1400',
        };
        let { onPopMenuIsShow } = props;
        setVisible(leftNum > -2);
        setActiveKey(activeKey);
        setPosition(newPosition);
        onPopMenuIsShow(true);
    }, [props.onPopMenuIsShow]);

    // 使用 useImperativeHandle 暴露方法给父组件
    useImperativeHandle(ref, () => ({
        show,
        hide
    }), [show, hide]);

    return visible ? (
        <div style={position} onMouseLeave={() => hide()} ref={menuBox}>
            {renderMenus()}
        </div>
    ) : null;
});

PopMenu.displayName = 'PopMenu';

export default PopMenu
